import Location from './utils/location';

export const PATH_DASHBOARD = Location.origin() + '/Home/Landing';
export const PATH_SECURITY_USERS = Location.origin() + '/Security/Users';

export const PATH_ROOT = '/ui/login/';
export const PATH_ROOT_DEFI = '/ui/login/defilogin';

export const PATH_LOGIN_FULL = PATH_ROOT;

export const PATH_LOGOUT = 'logout';
export const PATH_LOGOUT_SSO = 'ssologout';
export const PATH_LOGOUT_FULL = PATH_ROOT + PATH_LOGOUT;

export const PATH_EXPIRED = 'expired';
export const PATH_EXPIRED_FULL = PATH_ROOT + PATH_EXPIRED;

export const PATH_CHANGE_PASSWORD = 'change-password';
export const PATH_CHANGE_PASSWORD_FULL = PATH_CHANGE_PASSWORD;

export const PATH_FORGOT_PASSWORD = '/forgot-password';
export const PATH_FORGOT_PASSWORD_FULL = PATH_FORGOT_PASSWORD;

const PATH_PARAM_USERNAME = ':username';
export const PATH_RESET_PASSWORD = 'reset-password';
export const PATH_RESET_PASSWORD_ROUTE = `${PATH_RESET_PASSWORD}/${PATH_PARAM_USERNAME}`;
export const PATH_RESET_PASSWORD_FULL = `/ui/login/${PATH_RESET_PASSWORD_ROUTE}`;